
export default function(_DSB,_CONTEXT={}){

  return function( dataObj, yLabel, limit, sort)
  {

      _DSB.log('debug','format.table','Formatting....',[dataObj, yLabel, limit, sort]);
      if (!dataObj.size) return ``;

      /* (Shorter) Utils */
      const _t = (s) => s ? _DSB.helpers.run('format','value',[s.toString(), `titlecase`]) : ``; // To-Title
      const _s = (s) => s ? _DSB.helpers.run('format','value',[s.toString(), `slugify`]) : ``;   // To-Slug

      const sortTables = sort.tables || {};
      const sortTablesOrder = sortTables.order || 'asc';
      const sortRows = sort.rows || {};
      const sortRowsOrder = sortRows.order || 'asc';
      const sortRowsColumn = parseInt(sortRows.column, 10);
      const sortRowsType = sortRows.type;
      const compareOpts = sortRowsType === 'number' || sortRowsType === 'date' ? { numeric: true, senstivity: 'base' } : {};
      const months =  {'Jan':'01','Feb':'02','Mar':'03','Apr':'04','May':'05','Jun':'06','Jul':'07','Aug':'08','Sep':'09','Oct':'10','Nov':'11','Dec':'12'};

      const ROWS_HEADER = _t(yLabel);

      if (sortTables) {
        dataObj = new Map(Array.from(dataObj).sort((a, b) => {
          let A = a[0],
              B = b[0];
          return sortTablesOrder === 'asc' ? A.toLowerCase().localeCompare(B.toLowerCase()) : B.toLowerCase().localeCompare(A.toLowerCase());
        }));
      }

      let html = ``;
      dataObj.forEach((tableData, tableHeader) => {
        let tableRows = Array.from(tableData.values());
        let colHeaders = [ROWS_HEADER].concat(Array.from(tableRows[0].keys()));

        if(sortRows)
        {
          if(!isNaN(sortRowsColumn) && sortRowsColumn >= 0 && sortRowsType !== undefined)
          {
            tableData = new Map(Array.from(tableData).sort((a, b) => {
              let A = sortRowsColumn === 0 ? a[0] : a[1].get(colHeaders[sortRowsColumn]),
                  B = sortRowsColumn === 0 ? b[0] : b[1].get(colHeaders[sortRowsColumn]);

              if (sortRowsType === 'date') {
                let aDateArr = A.split(/-|\/|'|\s+/).filter(d => d).map(d => months[d.trim()] || d.trim());
                let bDateArr = B.split(/-|\/|'|\s+/).filter(d => d).map(d => months[d.trim()] || d.trim());
                A = aDateArr.reverse().join('');
                B = bDateArr.reverse().join('');
              }

              if ((sortRowsType === 'number' || sortRowsType === 'date') && sortRowsOrder === 'asc' && isNaN(parseFloat(B))) return -1;

              return sortRowsOrder === 'asc' ? A.toLowerCase().localeCompare(B.toLowerCase(), undefined, compareOpts) : B.toLowerCase().localeCompare(A.toLowerCase(), undefined, compareOpts);
            }));
          }
        }

        let rowHeaders = Array.from(tableData.keys()).slice(0, limit);
        let tableId = `table_${_s(tableHeader)}`;
        let count = 1;

        html += `<table id="${tableId}_${count}" >`;
        html += `<caption>${tableHeader}</caption>`;

        let headers = `
          <tr>
            ${colHeaders.reduce((prev, col) => `
              ${prev}
              <th scope="col" ${col ? `class="th--${_s(col)}" ` : `` }${col.toString().startsWith(`_`) ? `style="display:none;"` : ``}>
                ${col}
              </th>
            `, ``)}
          </tr>`;

        let rows = rowHeaders.reduce((prev, row) => `
          ${prev}
          <tr>
            ${row.toString().startsWith(`_`) ? `` : `<th scope="row" ${ colHeaders[0] ? `class="th--${_s(colHeaders[0])}"` : `` }>${row}</th>`}
            ${Array.from(tableData.get(row).values()).map((v,i) => `<td ${ colHeaders[i+1] ? `class="td--${_s(colHeaders[i+1])}"` : `` }>${v}</td>`).join(``)}
          </tr>`
        , ``);

        html += `<thead>${headers}</thead><tbody>${rows}</tbody></table>`;
      });

      // ---
      // @NOTE - STRIP whitespace
      // - Also makes it easier to run regEx on it later
      // - Takes into account various HTML el's (even though this only deals with table markup)
      // - https://stackoverflow.com/a/40026669
      const RE_HTML_WHITESPACE = /(<(pre|script|style|textarea)[^]+?<\/\2)|(^|>)\s+|\s+(?=<|$)/gi;
      html = html.replace(RE_HTML_WHITESPACE, `$1$3`);
      // ---

      return html;
  }
}
